import React, { useEffect, useState } from 'react';
import { addItemToApp, getAllItemsByApp } from './AppService';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const AttachAppItem = ({ listAppItems, appId }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<any[]>([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    listItems();
  }, [appId]);

  function listItems() {
    setLoading(true); // Set loading to true before fetching items
    getAllItemsByApp(appId)
      .then((response) => {
        setItems(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false); // Reset loading state
      });
  }

  const handleChange = (itemId) => {
    setSelectedItemId(itemId);
  };

  const handleClickOpen = () => {
    listAppItems();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  function attachSelectedItem(appId, itemId) {
    if (!itemId) {
      console.error('No item selected');
      return;
    }

    addItemToApp(appId, itemId)
      .then(() => {
        listAppItems();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      {/* Disable button if items are still loading */}
      <Button onClick={handleClickOpen} disabled={loading}>
        Select Item
      </Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <Select
                native
                value={selectedItemId || ''} // Use selectedItemId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select Item" id="demo-dialog-native" />
                }
              >
                <option value={''} disabled>
                  Select Item
                </option>
                {items.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button
            onClick={() => attachSelectedItem(appId, selectedItemId)}
            disabled={!selectedItemId} // Disable if no item is selected
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachAppItem;
